import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import { UserContext } from '../../context/UserContext'
import { Avatar, Box, Dialog, IconButton, Typography } from '@mui/material'
import { Menu, WavingHand } from '@mui/icons-material'
import { CreatePost } from '../post/CreatePost'
import { MainMenu } from './MainMenu'

const NavBtn = ({ icon, label, onClick }) => (
    <Box
        onClick={onClick}
        sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            py: 0.75,
            cursor: 'pointer',
            color: '#555',
            '&:hover': { color: '#732982' },
            '& .MuiSvgIcon-root': { fontSize: 24 },
        }}
    >
        {icon}
        <Typography sx={{ fontSize: 10, mt: 0.25, fontWeight: 600, lineHeight: 1 }}>{label}</Typography>
    </Box>
)

export default function MainBottomNavigation() {
    const [open, setOpen] = React.useState(false)
    const [openMenu, setOpenMenu] = React.useState(false)
    const [status, setStatus] = React.useState('')
    const navigate = useNavigate()
    const { userDetails } = React.useContext(UserContext)

    return (
        <>
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                background: '#fff',
                borderTop: '1px solid #ececf0',
                height: 56,
                boxShadow: '0 -2px 12px rgba(0,0,0,0.06)',
            }}>
                {/* Explore and Upload hidden for now — not yet fixed/tested/perfected */}
                <NavBtn icon={<WavingHand />} label="Meet" onClick={() => navigate('/meet')} />
                <NavBtn
                    icon={<Avatar src={userDetails?.avatar} sx={{ width: 26, height: 26 }} />}
                    label="Profile"
                    onClick={() => navigate('/profile/' + userDetails?.id)}
                />
                <NavBtn icon={<Menu />} label="Menu" onClick={() => setOpenMenu(true)} />
            </Box>

            <CreatePost
                token={userDetails?.token}
                open={open}
                setOpen={setOpen}
                status={status}
                setStatus={setStatus}
                buttonTitle="Upload Status"
                visibility="public"
            />

            <Dialog onClose={() => setOpenMenu(false)} open={openMenu} PaperProps={{ sx: { m: 0, borderRadius: 3 } }}>
                <Box sx={{ width: 260 }} onClick={() => setOpenMenu(false)}>
                    <Box sx={{ height: 4, background: 'linear-gradient(90deg,#E40303,#FF8C00,#FFED00,#008026,#24408E,#732982)' }} />
                    <MainMenu />
                </Box>
            </Dialog>
        </>
    )
}
